
 
 // =============================== Hero Product Rotate =========================== //
if(document.querySelector(".hero-section")){
  gsap.to(".hero-img img", {
    rotate:13,
    scrollTrigger:{
      trigger:".hero-section",
      start:"top center",
      end:"bottom center",
      scrub:true
    }
  });
}
  // =============================== Hero Product Rotate =========================== //


  

  // =============================== Star Marquee =========================== //

function generatePattern(svgId, bgColor, shapeColor) {
        const svg = document.getElementById(svgId);
        if (!svg) return;

        const tileW = 34;
        const tileH = 34;
        const count = Math.ceil(window.innerWidth / tileW);

        svg.setAttribute("viewBox", `0 0 ${count * tileW} ${tileH}`);
        svg.setAttribute("preserveAspectRatio", "none");

        const tile = `
      <rect width="${tileW}" height="${tileH}" fill="${bgColor}"/>
      <path d="M8 17L12.6937 14.8787L17 17L12.6937 19.1213L8 17Z" fill="${shapeColor}"/>
      <path d="M17 17L21.6937 14.8787L26 17L21.6937 19.1213L17 17Z" fill="${shapeColor}"/>
      <path d="M17 8L19.1213 12.6937L17 17L14.8787 12.6937L17 8Z" fill="${shapeColor}"/>
      <path d="M17 17L19.1213 21.6937L17 26L14.8787 21.6937L17 17Z" fill="${shapeColor}"/>
    `;

        let inner = "";
        for (let i = 0; i < count; i++) {
          inner += `<g transform="translate(${i * tileW}, 0)">${tile}</g>`;
        }

        svg.innerHTML = inner;
      }

      // Call function for each SVG
      generatePattern("repeat-svg", "#FFF2DE", "#FF3909");
      generatePattern("repeat-svg2", "#FF3909", "#FFF2DE");
      generatePattern("repeat-svg3", "#FF3909", "#FFF2DE");
      generatePattern("repeat-svg4", "#FFF2DE", "#FF3909");
      generatePattern("repeat-svg5", "#FFF2DE", "#FF3909");
        generatePattern("repeat-svg6", "#FFF2DE", "#FF3909");
        generatePattern("repeat-svg7", "#FFF2DE", "#FF3909");
         generatePattern("repeat-svg8", "#FFF2DE", "#FF3909");

      // Optional: regenerate on resize (for responsive)
      window.addEventListener("resize", () => {
        generatePattern("repeat-svg", "#FFF2DE", "#FF3909");
        generatePattern("repeat-svg2", "#FF3909", "#FFF2DE");
        generatePattern("repeat-svg3", "#FF3909", "#FFF2DE");
        generatePattern("repeat-svg4", "#FFF2DE", "#FF3909");
        generatePattern("repeat-svg5", "#FFF2DE", "#FF3909");
        generatePattern("repeat-svg6", "#FFF2DE", "#FF3909");
         generatePattern("repeat-svg7", "#FFF2DE", "#FF3909");
                  generatePattern("repeat-svg8", "#FFF2DE", "#FF3909");
      });
   
  // =============================== Star Marquee =========================== //
  
  



   // =============================== Verticle Marquee =========================== //
function generateVerticalPatternBar(svgId, bgColor, shapeColor) {

  const svg = document.getElementById(svgId);
  if (!svg) return;

  const tileW = 34;
  const tileH = 34;

  const containerHeight = svg.parentElement.offsetHeight;
  const count = Math.ceil(containerHeight / tileH);

  svg.setAttribute("viewBox", `0 0 ${tileW} ${count * tileH}`);
  svg.setAttribute("preserveAspectRatio", "none");

  const tile = `
  <rect width="${tileW}" height="${tileH}" fill="${bgColor}"/>
  <path d="M8 17L12.6937 14.8787L17 17L12.6937 19.1213L8 17Z" fill="${shapeColor}"/>
  <path d="M17 17L21.6937 14.8787L26 17L21.6937 19.1213L17 17Z" fill="${shapeColor}"/>
  <path d="M17 8L19.1213 12.6937L17 17L14.8787 12.6937L17 8Z" fill="${shapeColor}"/>
  <path d="M17 17L19.1213 21.6937L17 26L14.8787 21.6937L17 17Z" fill="${shapeColor}"/>
  `;

  let inner = "";

  for (let i = 0; i < count; i++) {
    inner += `<g transform="translate(0, ${i * tileH})">${tile}</g>`;
  }

  svg.innerHTML = inner;
}

/* run once */
function generateAllPatterns(){
    generateVerticalPatternBar("vertical-pattern-left-svg","#FFF2DE","#FF3909");
  generateVerticalPatternBar("vertical-pattern-right-svg","#FFF2DE","#FF3909");
  generateVerticalPatternBar("vertical-pattern-left-svg-blog","#FFF2DE","#FF3909");
  generateVerticalPatternBar("vertical-pattern-right-svg-blog","#FFF2DE","#FF3909");
    generateVerticalPatternBar("vertical-pattern-left-svg-recipe","#FFF2DE","#FF3909");
  generateVerticalPatternBar("vertical-pattern-right-svg-recipe","#FFF2DE","#FF3909");
      generateVerticalPatternBar("vertical-pattern-left-svg-shared","#FFF2DE","#FF3909");
  generateVerticalPatternBar("vertical-pattern-right-svg-shared","#FFF2DE","#FF3909");
}

generateAllPatterns();

/* regenerate on resize */
window.addEventListener("resize", generateAllPatterns);
     // =============================== Verticle Marquee =========================== //





  // =============================== Diamond Marquee =========================== //
function mmCreateDiamondMarquee() {

  const tracks = document.querySelectorAll(".mm-marquee-track");
  if (!tracks.length) return;

  const svgWidth = 23;
  const gap = 20;
  const screenWidth = window.innerWidth;
  const count = Math.ceil(screenWidth / (svgWidth + gap)) * 3;

  const svgPattern = `
  <svg viewBox="0 0 23 39" xmlns="http://www.w3.org/2000/svg">
    <rect x="11.3125" y="8" width="16" height="16"
    transform="rotate(45 11.3125 8)" fill="#FF3909"/>
  </svg>
  `;

  let patternHTML = "";

  for (let i = 0; i < count; i++) {
    patternHTML += svgPattern;
  }

  tracks.forEach(track => {
    track.innerHTML = patternHTML + patternHTML;
  });

}

mmCreateDiamondMarquee();
window.addEventListener("resize", mmCreateDiamondMarquee);

  // =============================== Diamond Marquee =========================== //



const bowl = document.querySelector(".protein-bowl");

document.querySelectorAll(".protein-btn").forEach(btn => {

  btn.addEventListener("click", function(e){

    e.preventDefault();

    const protein = this.dataset.protein;

    /* image switch */
    bowl.querySelectorAll(".protein-img").forEach(img=>{
      img.classList.remove("active");
    });

    bowl.querySelector("." + protein).classList.add("active");

    /* bowl state */
    bowl.classList.remove("tofu-active","chicken-active");
    bowl.classList.add(protein + "-active");

    /* button state */
    document.querySelectorAll(".protein-btn").forEach(b=>{
      b.classList.remove("active");
    });

    this.classList.add("active");

  });

});


document.addEventListener("DOMContentLoaded", function () {

  // ── Accordion ──────────────────────────────────────────────
  const items = document.querySelectorAll(".pd-accordion-wrapper [data-accordion-item]");

  items.forEach(item => {
    const btn  = item.querySelector("[data-accordion-trigger]");
    const body = item.querySelector("[data-accordion-body]");

    if (item.classList.contains("pd-item--open")) {
      body.style.height = body.scrollHeight + "px";
    }

    btn.addEventListener("click", function () {
      const isOpen = item.classList.contains("pd-item--open");

      items.forEach(other => {
        const otherBody = other.querySelector("[data-accordion-body]");
        other.classList.remove("pd-item--open");
        otherBody.style.height = "0px";
        other.querySelector("[data-accordion-trigger]").setAttribute("aria-expanded", "false");
      });

      if (!isOpen) {
        item.classList.add("pd-item--open");
        body.style.height = body.scrollHeight + "px";
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  // ── Nutrition chart popup ───────────────────────────────────
  const modal        = document.getElementById("pd-nutrition-modal");
  const openTrigger  = document.querySelector("[data-nutrition-trigger]");
  const closeTriggers = document.querySelectorAll("[data-nutrition-close]");

  if (modal && openTrigger) {

    // Open
    openTrigger.addEventListener("click", function () {
      modal.hidden = false;
      document.body.style.overflow = "hidden";   // prevent background scroll
      modal.querySelector(".pd-nutrition-modal__close").focus();
    });

    // Close — backdrop click or close button
    closeTriggers.forEach(el => {
      el.addEventListener("click", closeModal);
    });

    // Close on Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) closeModal();
    });

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = "";
      openTrigger.focus();                       // return focus to trigger
    }
  }

});



// document.addEventListener("DOMContentLoaded",function(){

// const items=document.querySelectorAll(".pd-accordion-wrapper [data-accordion-item]")

// items.forEach(item=>{

// const btn=item.querySelector("[data-accordion-trigger]")
// const body=item.querySelector("[data-accordion-body]")

// if(item.classList.contains("pd-item--open")){
// body.style.height=body.scrollHeight+"px"
// }

// btn.addEventListener("click",function(){

// const isOpen=item.classList.contains("pd-item--open")

// items.forEach(other=>{

// const otherBody=other.querySelector("[data-accordion-body]")
// other.classList.remove("pd-item--open")
// otherBody.style.height="0px"

// const otherBtn=other.querySelector("[data-accordion-trigger]")
// otherBtn.setAttribute("aria-expanded","false")

// })

// if(!isOpen){

// item.classList.add("pd-item--open")
// body.style.height=body.scrollHeight+"px"
// btn.setAttribute("aria-expanded","true")

// }

// })

// })

// })